module.exports = __webpack_public_path__ + "img/train-stop-top.6186c607.png";